import { defineMessages } from 'react-intl';

export default defineMessages({
  addAllString: {
    id: 'addAllToCart',
    description: 'add all to cart',
    defaultMessage: 'Add All to cart',
  },
  lockedString: {
    id: 'locked',
    description: 'locked',
    defaultMessage: 'locked',
  },
});
